import React from "react";
const SecTitle = ({ title }) => {
  return (
    <div className="text-center my-5">
      <h2 className="text-center h4 sec_header_title py-3 px-5">
        {title}
        <img
          src="/images/svg/bottom-left-title-botder.svg"
          alt=""
          className="bottom-left_border"
        />
        <img
          src="/images/svg/top-right-title-botder.svg"
          alt=""
          className="top-right_border"
        />
      </h2>
    </div>
  );
};

export default SecTitle;
